export default __webpack_public_path__ + "static/media/technologyLogo.1c8264ff.png";